import { useEffect, useState } from 'preact/hooks';
import { debounce } from '@/utils';
import { usePrevious } from '@/hooks';

function getWidth(formType) {
	const windowWidth = window.innerWidth;

	if (windowWidth > 1201) {
		return formType === 'slide' ? '425px' : '40%';
	} else if (windowWidth > 992 && windowWidth < 1201) {
		return formType === 'slide' ? '400px' : '45%';
	} else if (windowWidth < 993 && windowWidth > 768) {
		return formType === 'slide' ? '360px' : '60%';
	} else if (windowWidth < 769 && windowWidth > 544) {
		return formType === 'slide' ? '360px' : '70%';
	} else if (windowWidth < 545 && windowWidth > 360) {
		return formType === 'slide' ? window.innerWidth * 0.8 + 'px' : '90%';
	}
	return formType === 'slide' ? window.innerWidth - 24 + 'px' : '90%';
}

function getWidthClass(clientWidth) {
	let className = '';

	if (clientWidth < 360) {
		className = 'mop-view-xs';
	}

	if (clientWidth < 400) {
		className += ' mop-view-sm';
	}

	if (clientWidth < 480) {
		className += ' mop-view-md';
	}

	className += ' mop-view-lg';

	return className;
}

export default function useFormWidth({ formType, contentDivRef, webView }) {
	const webViewOrEmbed = webView || formType === 'embed';
	const [width, setWidth] = useState(getWidth(formType));
	const [clientWidth, setClientWidth] = useState(contentDivRef.current?.clientWidth);
	const prevFormType = usePrevious(formType);

	useEffect(() => {
		const handleResize = debounce(() => {
			const newWidth = getWidth(formType);
			if (newWidth !== width) {
				setWidth(newWidth);
				//contentDivRef.current?.clientWidth equals 0 after taking a screenshot.
				//store clientWidth in state to prevent widthClass becoming 'mop-view-sm' after returning from screenshot.
			}
			setClientWidth(contentDivRef.current?.clientWidth);
		}, 100);

		window.addEventListener('resize', handleResize);

		if (prevFormType !== formType) {
			handleResize();
		}

		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, [width, prevFormType, formType, contentDivRef, webViewOrEmbed]);

	return {
		formWidth: width,
		widthClass: getWidthClass(contentDivRef.current?.clientWidth || clientWidth),
		clientWidth
	};
}
